export const equipmentIdTypes = [
  'technicalId',
  'sapNumber',
  'processId',
  'mainEquipmentCustomId',
  'janusId'
] as const
export type EquipmentIdType = (typeof equipmentIdTypes)[number]

export const EquipmentCategory = {
  CEMENT: 'cement',
  CLINKER: 'clinker',
  CRUSHER: 'crusher',
  RAW: 'raw',
  COAL: 'coal',
  UNKNOWN: 'unknown',
  ENVIRONMENTAL: 'Environmental',
  PACKING: 'Packing',
  FUEL: 'Fuel'
} as const
export type EquipmentCategory = (typeof EquipmentCategory)[keyof typeof EquipmentCategory]

export const EquipmentType = {
  KILN: 'kiln',
  VERTICAL_MILL: 'verticalMill',
  ROLLER_PRESS: 'rollerPress',
  DOSING_EQUIPMENT: 'dosingEquipment',
  BALL_MILL: 'ballMill',
  OTHER: 'other'
} as const
export type EquipmentType = (typeof EquipmentType)[keyof typeof EquipmentType]

export type EquipmentData = {
  idType?: EquipmentIdType
  id: string
  text?: string
  equipmentCategory?: EquipmentCategory
  equipmentType?: EquipmentType
}

export interface Attachment {
  id: number
  fileName: string
  mediaType: string
  url: string
  previewMediaType?: string
  previewUrl?: string
}
